import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from '@modules/authentication/components/login/login.component';
import {LogoutComponent} from '@modules/authentication/components/logout/logout.component';
import {AuthGuard} from '@core/guard/auth.guard';
import {LoginGuard} from '@core/guard/login.guard';
// import {SignUpComponent} from './sign-up/sign-up.component';
export const ROUTES = {
  PREFIX: 'auth',
  LOGIN: 'login',
  LOGOUT: 'logout-successfully'
};

const routes: Routes = [
  {
    path: ROUTES.LOGIN,
    component: LoginComponent,
    canActivate: [LoginGuard],
    title: 'Trang quản trị',
    data: {
      title: 'Login'
    }
  },
  {
    path: ROUTES.LOGOUT,
    component: LogoutComponent,
    title: 'Trang quản trị',
    data: {
      title: 'Logout'
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthenticationRoutingModule {
}
